import {
  CalendarToday,
  DateRange,
  Inventory,
  LocalShipping,
  Today
} from '@mui/icons-material';
import { Box, Grid, Paper, Typography } from '@mui/material';
import React from 'react';
import CompactBreakdownCard from './CompactBreakdownCard';
import CompactStatCard from './CompactStatCard';
import SectionHeader from './SectionHeader';

export default function DailyView({
  packageDetailsData,
  zoeShipmentTrackingData,
  loading,
  onNavigateToPackageByDate,
  onNavigateToShipmentByDate
}) {
  if (!packageDetailsData || !zoeShipmentTrackingData) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="200px"
      >
        <Typography variant="h6" color="textSecondary">
          {loading ? 'Loading dashboard data...' : 'No data available'}
        </Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      {/* Package Details Daily */}
      <Grid item xs={12}>
        <Paper sx={{ p: 3 }}>
          <SectionHeader
            title="Package Details - Daily Overview"
            icon={<Inventory />}
          />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <CompactStatCard
                title="Today"
                value={packageDetailsData.daily.today}
                subtitle="Packages processed today"
                icon={<Today />}
                color="primary"
                onNavigate={() => onNavigateToPackageByDate('Today')}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CompactStatCard
                title="Yesterday"
                value={packageDetailsData.daily.yesterday}
                subtitle="Previous day total"
                icon={<CalendarToday />}
                color="secondary"
                onNavigate={() => onNavigateToPackageByDate('Yesterday')}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CompactStatCard
                title="This Week"
                value={packageDetailsData.daily.thisWeek}
                subtitle="7-day total"
                icon={<DateRange />}
                color="info"
                onNavigate={() => onNavigateToPackageByDate('This Week')}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CompactBreakdownCard
                title="Today's Breakdown"
                items={[
                  {
                    label: `Incoming: ${packageDetailsData.daily.incoming}`,
                    color: 'success'
                  },
                  {
                    label: `Outgoing: ${packageDetailsData.daily.outgoing}`,
                    color: 'warning'
                  },
                  {
                    label: `Unclassified: ${packageDetailsData.daily.unclassified}`,
                    color: 'error'
                  }
                ]}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>

      {/* Zoe Shipment Tracking Daily */}
      <Grid item xs={12}>
        <Paper sx={{ p: 3 }}>
          <SectionHeader
            title="Zoe Shipment Tracking - Daily Overview"
            icon={<LocalShipping />}
          />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <CompactStatCard
                title="Today"
                value={zoeShipmentTrackingData.daily.today}
                subtitle="Shipments processed today"
                icon={<Today />}
                color="primary"
                onNavigate={() => onNavigateToShipmentByDate('Today')}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CompactStatCard
                title="Yesterday"
                value={zoeShipmentTrackingData.daily.yesterday}
                subtitle="Previous day total"
                icon={<CalendarToday />}
                color="secondary"
                onNavigate={() => onNavigateToShipmentByDate('Yesterday')}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CompactStatCard
                title="This Week"
                value={zoeShipmentTrackingData.daily.thisWeek}
                subtitle="7-day total"
                icon={<DateRange />}
                color="info"
                onNavigate={() => onNavigateToShipmentByDate('This Week')}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CompactBreakdownCard
                title="Today's Status"
                items={[
                  {
                    label: `Delivered: ${zoeShipmentTrackingData.daily.delivered}`,
                    color: 'success'
                  },
                  {
                    label: `In Transit: ${zoeShipmentTrackingData.daily.inTransit}`,
                    color: 'info'
                  },
                  {
                    label: `Checked In: ${zoeShipmentTrackingData.daily.checkedIn}`,
                    color: 'primary'
                  },
                  {
                    label: `Checked Out: ${zoeShipmentTrackingData.daily.checkedOut}`,
                    color: 'secondary'
                  },
                  {
                    label: `Pending: ${zoeShipmentTrackingData.daily.pending}`,
                    color: 'warning'
                  },
                  {
                    label: `Unclassified: ${zoeShipmentTrackingData.daily.unclassified}`,
                    color: 'error'
                  }
                ]}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
}
